import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { ConfigService } from 'src/app/core';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
})
export class ImageComponent {
  @Input() imageId!: string;
  @Input() alt?: string;
  @Input() name?: string;

  @HostBinding('class.image') class = () => true;

  public baseUrl = '';

  constructor(private config: ConfigService) {
    this.baseUrl = config.getBaseUrl();
  }
}
